module.exports = __webpack_public_path__ + "0.main.worker.js"